/**
 * Council value normalization.
 *
 * The embed snippet is `<script ... data-council="Newcastle">`. Some council
 * CMSes auto-convert the straight quotes into smart/curly quotes, so the value
 * actually delivered is e.g. U+201C + Newcastle + U+0022 ('“Newcastle"'). That
 * corrupted string fails every downstream council resolver (the widget XSS
 * allow-list regex, the portal substring match, and the portal proxy allow-list),
 * silently falling back to the default tenant.
 *
 * normalizeCouncilValue strips leading/trailing whitespace and quote-like chars
 * (straight " ' , curly “ ” ‘ ’ , backtick `) from BOTH ENDS ONLY, leaving
 * interior characters untouched. Clean values pass through unchanged.
 */

const COUNCIL_WRAP_CHARS = /^[\s"'“”‘’`]+|[\s"'“”‘’`]+$/g;

/**
 * @param {*} raw - raw council value (data-council attr, URL param, or storage)
 * @returns {string} normalized council value, or '' for null/undefined/empty
 */
export function normalizeCouncilValue(raw) {
    if (raw == null) return '';
    return String(raw).replace(COUNCIL_WRAP_CHARS, '');
}
